import _ from 'lodash'

import {
  ADD_DISTRICT_USER_FIELD_ERROR,
  ADD_DISTRICT_USER_FIELDS_ERRORS,
  CHANGE_DISTRICT_USER_FORM_FIELD,
  CLEAR_DISTRICT_USER_FIELD_ERROR,
  PREDEFINE_DISTRICT_USER_FORM_DATA,
  RESET_DISTRICT_USER_FORM_DATA,
} from './actions'

const defaultFormData = (predefined = {}) =>
  _.merge(
    {
      id: '',
      email: '',
      fullName: '',
      officePhone: '',
      mobilePhone: '',
      roleId: '',
      personTypeId: '',
    },
    _.pickBy(predefined, _.identity),
  )

export const initialState = () => ({
  data: defaultFormData(),
  errors: {},
})

export default function root(state = initialState(), action) {
  switch (action.type) {
    case CHANGE_DISTRICT_USER_FORM_FIELD:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.key]: action.payload.value,
        },
      }

    case ADD_DISTRICT_USER_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: action.payload.error,
        },
      }

    case ADD_DISTRICT_USER_FIELDS_ERRORS:
      return {
        ...state,
        errors: action.payload.errors,
      }

    case CLEAR_DISTRICT_USER_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: undefined,
        },
      }

    case RESET_DISTRICT_USER_FORM_DATA:
      return {
        ...state,
        data: defaultFormData(),
        errors: {},
      }

    case PREDEFINE_DISTRICT_USER_FORM_DATA:
      return {
        ...state,
        data: defaultFormData(action.payload),
        errors: {},
      }

    default:
      return state
  }
}
